// Text for the 'jelly' world: its name on the map, the level titles and the comic word in the scene, per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Gelébjerge',
    scene: { wiggle: 'VRIK!' },
    levels: {
      'wiggle': { title: 'Vrik' },
      'stop': { title: 'Stop' },
      'clack': { title: 'Klak' },
      'high-hop': { title: 'Højt hop' },
      'heavy-ball': { title: 'Tung kugle' },
      'soft-landing': { title: 'Blød landing' },
      'angle': { title: 'Vinkel' },
      'light-push': { title: 'Let puf' },
      'double-hop': { title: 'Dobbelt hop' },
      'small-hop': { title: 'Lille hop' },
      'heavy-vs-heavy': { title: 'Tung mod tung' },
      'push-and-hop': { title: 'Skub og hop' },
      'clack-and-stop': { title: 'Klak og stop' },
      'push-hop-stop': { title: 'Skub, hop og stop' },
      'master': { title: 'Mester' },
    },
  },
  en: {
    name: 'Jelly mountains',
    scene: { wiggle: 'WIGGLE!' },
    levels: {
      'wiggle': { title: 'Wiggle' },
      'stop': { title: 'Stop' },
      'clack': { title: 'Clack' },
      'high-hop': { title: 'High hop' },
      'heavy-ball': { title: 'Heavy ball' },
      'soft-landing': { title: 'Soft landing' },
      'angle': { title: 'Angle' },
      'light-push': { title: 'Gentle push' },
      'double-hop': { title: 'Double hop' },
      'small-hop': { title: 'Little hop' },
      'heavy-vs-heavy': { title: 'Heavy against heavy' },
      'push-and-hop': { title: 'Push and hop' },
      'clack-and-stop': { title: 'Clack and stop' },
      'push-hop-stop': { title: 'Push, hop and stop' },
      'master': { title: 'Master' },
    },
  },
});
